import React from 'react';

export const FormSectionTitle: React.FC<{
  text: string;
  htmlFor?: string;
  id?: string;
}> = (props) => {
  return (
    <label
      className={'text-[--c-textinput-label] font-bold text-lg block'}
      htmlFor={props.htmlFor}
      id={props.id}
    >
      {props.text}
    </label>
  );
};
